import { Button, Tooltip } from "@material-ui/core";
import React from "react";

import { useAlert } from "react-alert";

import { makeRequest } from "../util";
import { DownloadIcon } from "../components/icons/themes/materialdesign";

export type DownloadReportButtonProps = {
  reportID: string;
};

function DownloadReportButton({ reportID }: DownloadReportButtonProps) {
  const alert = useAlert();
  const [loading, setLoading] = React.useState(false);

  const handleClick = () => {
    if (loading) {
      return;
    }

    setLoading(true);

    const now = new Date().getTime();

    makeRequest<string>("get_web_tracker_report_download_link", { reportID })
      .then((res) => {
        // Add a minimum artificial delay of 500ms to allow the loading spinner to show
        const elapsed = new Date().getTime() - now;
        const minLoadingDelay = elapsed < 500 ? 500 - elapsed : 0;

        setTimeout(() => {
          window.open(res.data, "_blank");
          setLoading(false);
        }, minLoadingDelay);
      })
      .catch((err) => {
        alert.error(
          "Failed to download report. Please try again later or contact support for assistance."
        );
        setLoading(false);
        console.error(err);
      });
  };

  return (
    <Tooltip title="Download the report in Excel .xlsx format." arrow>
      <Button
        color="primary"
        disabled={loading}
        size="small"
        variant="contained"
        onClick={handleClick}
      >
        <DownloadIcon />
      </Button>
    </Tooltip>
  );
}

export default DownloadReportButton;
